/**
 * Trip:
 * * TripDaysTabbar
 * * MapView
 * * FullTrip
 * * DayTrip
 */

import React from 'react';
import propTypes from 'prop-types';

import MapView from './MapView';
import FullTrip from './FullTrip2';
import DayTrip from './DayTrip';
import {connect} from 'react-redux';
import { selectDay } from '../../../store/actions/trip';
import * as routeAction from '../../../store/actions/route';
import * as selector from '../selector';

class TripContainer extends React.Component {
  static propTypes = {
    trip: propTypes.object.isRequired,
    day: propTypes.number.isRequired,
    route: propTypes.object,
    routeStatus: propTypes.string,
    fullTripRoute: propTypes.object,
    fullTripRouteStatus: propTypes.string
  };

  render() {
    return (<Trip {...this.props} />);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.day !== this.props.day) {
      this.fetchRouteData(nextProps);
    }
  }

  componentDidMount() {
    this.fetchRouteData(this.props);
  }

  fetchRouteData(props) {
    let {trip, day, getFullTripRoute} = props;

    if (day === 0) {
      getFullTripRoute(trip);
    }

    // 在TripMapView实现
    // getDayTripRoute(trip, day);
  }
}


Trip.propTypes = {
  trip: propTypes.object.isRequired,
  day: propTypes.number.isRequired,
  route: propTypes.object,
  routeStatus: propTypes.string,
  fullTripRoute: propTypes.object,
  fullTripRouteStatus: propTypes.string
};

function Trip(props) {
  let {day, trip, route, routeStatus, selectDay, fullTripRoute, fullTripRouteStatus} = props;

  return (
    <div className='trip'>
      <MapView
        trip={trip}
        day={day}
        route={route}
        fullTripRoute={fullTripRoute} />
      {
        day > 0
          ? (
            <DayTrip
              trip={trip}
              day={day}
              route={route}
              routeStatus={routeStatus} />
          )
          : (
            <FullTrip
              trip={trip}
              fullTripRoute={fullTripRoute}
              selectDay={selectDay}
              fullTripRouteStatus={fullTripRouteStatus} />
          )
      }
    </div>
  );
}

export default connect(function (state, ownProps) {
  return {
    ...ownProps,
    route: selector.route(state),
    routeStatus: selector.routeStatus(state),
    fullTripRoute: selector.fullTripRoute(state),
    fullTripRouteStatus: selector.fullTripRouteStatus(state)
  };
}, {
  selectDay,
  ...routeAction
})(TripContainer);



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/index.js